// Catalog registry for "field groups": a named group whose `+ Add` menu offers a
// predefined set of options. The admin curates which options the group exposes in
// the builder, and the visitor picks which to fill on the public form. Each option
// becomes a flat member field carrying its own mapped_attribute, so the existing
// per-field mapping (frontend + backend) is reused — see FormFieldGroup.vue and
// public/api/v1/forms_controller.rb#flatten_fields.
//
// Adding a new catalog (e.g. addresses, alternate contacts) is a single entry here.

const SOCIAL_ICONS = {
  facebook: 'M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z',
  instagram:
    'M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5z M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z M17.5 6.5h.01',
  linkedin:
    'M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-4 0v7h-4v-7a6 6 0 016-6z M2 9h4v12H2z M4 2a2 2 0 110 4 2 2 0 010-4z',
  twitter: 'M4 4l11.733 16H20L8.267 4H4z M4 20l6.768-6.768M13.232 10.768L20 4',
  github:
    'M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22',
  tiktok: 'M14 3v9.5a4.5 4.5 0 11-4-4.47V12a1.5 1.5 0 101 1.41V3h3zm0 0c1 3 3 5 6 5',
};

// Generic "share" icon for the Social Media palette/group header.
const SHARE_ICON =
  'M8.7 10.7l6.6-3.4M8.7 13.3l6.6 3.4M18 8a3 3 0 10-3-3 3 3 0 003 3zm0 11a3 3 0 10-3-3 3 3 0 003 3zM6 15a3 3 0 100-6 3 3 0 000 6z';

export const GROUP_CATALOGS = {
  social_media: {
    paletteLabelKey: 'FORM_BUILDER.PALETTE.SOCIAL_GROUP',
    paletteDescKey: 'FORM_BUILDER.PALETTE.SOCIAL_GROUP_DESC',
    defaultLabelKey: 'FORM_BUILDER.GROUP.SOCIAL_MEDIA_LABEL',
    icon: SHARE_ICON,
    options: [
      {
        key: 'facebook',
        labelKey: 'FORM_BUILDER.PALETTE.CONTACT_FACEBOOK',
        mapped_attribute: 'contact.social_profiles.facebook',
        field_type: 'text',
        icon: SOCIAL_ICONS.facebook,
      },
      {
        key: 'instagram',
        labelKey: 'FORM_BUILDER.PALETTE.CONTACT_INSTAGRAM',
        mapped_attribute: 'contact.social_profiles.instagram',
        field_type: 'text',
        icon: SOCIAL_ICONS.instagram,
      },
      {
        key: 'linkedin',
        labelKey: 'FORM_BUILDER.PALETTE.CONTACT_LINKEDIN',
        mapped_attribute: 'contact.social_profiles.linkedin',
        field_type: 'text',
        icon: SOCIAL_ICONS.linkedin,
      },
      {
        key: 'twitter',
        labelKey: 'FORM_BUILDER.PALETTE.CONTACT_TWITTER',
        mapped_attribute: 'contact.social_profiles.twitter',
        field_type: 'text',
        icon: SOCIAL_ICONS.twitter,
      },
      {
        key: 'github',
        labelKey: 'FORM_BUILDER.PALETTE.CONTACT_GITHUB',
        mapped_attribute: 'contact.social_profiles.github',
        field_type: 'text',
        icon: SOCIAL_ICONS.github,
      },
      {
        key: 'tiktok',
        labelKey: 'FORM_BUILDER.PALETTE.CONTACT_TIKTOK',
        mapped_attribute: 'contact.social_profiles.tiktok',
        field_type: 'text',
        icon: SOCIAL_ICONS.tiktok,
      },
    ],
  },
};

export function getCatalog(catalogKey) {
  return GROUP_CATALOGS[catalogKey] || null;
}

// Build a member field for a group from a catalog option. `name` is a stable,
// unique storage key (group id + option key) used by the backend mapping.
export function newGroupMember(groupId, option, translate) {
  return {
    name: `${groupId}_${option.key}`,
    key: option.key,
    field_type: option.field_type || 'text',
    label: translate ? translate(option.labelKey) : option.labelKey,
    placeholder: '',
    mapped_attribute: option.mapped_attribute,
    icon: option.icon,
  };
}
